import { isLocalhost } from './consts';

export const config = {
  appId: '70136a30-7b98-45ca-8026-5e00e57c4b79',
  redirectUri: isLocalhost() ? 'http://localhost:3000' : 'https://ltc-demo.vvtdev.com',
  scopes: ['user.read'],
  authority: 'https://login.microsoftonline.com/velvetech.onmicrosoft.com',
  landingURL: 'https://www.ltclegalrisk.com/',
};
